export const versions = {
  version: "1.0.183",
  revision: "e3a5d4fc3",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5105-ge3a5d4fc3-dirty",
    hash: "ge3a5d4fc3",
    distance: 5105,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5105-ge3a5d4fc3-dirty",
    semverString: "1.0.183+5105.ge3a5d4fc3.dirty"
  }
};
